import useRouter from 'AppShell/hooks/useRouter';
import { getPageTypeByUrl } from './pageTypeService';
import { PageType } from 'AppShell/appshell_types/routingTypes';
import useConfig from 'AppShell/hooks/useConfig';
import { useCallback } from 'react';

export const bellaPageTypes = [
    PageType.ALLPRODUCTS,
    PageType.NEWPRODUCTS,
    PageType.LANDING,
    PageType.BRANDS,
    PageType.CATEGORY,
    PageType.HOMEPAGE,
    PageType.PDP,
    PageType.LOOKS_WISHLIST,
    PageType.INTERIOR_DESIGN_SERVICE,
    PageType.CHECKOUT,
    PageType.CART,
    PageType.CART_NATIVE,
    PageType.LOOKS,
    PageType.B2B,
];

export const clubMFPageTypes = [PageType.CLUB_UPCOMING_CAMPAIGN, PageType.CLUB_SERVICE_PAGE, PageType.CLUB_PDP];

export const useCurrentPageType = () => {
    const {
        location: { pathname },
        host,
    } = useRouter();

    return getPageTypeByUrl(pathname, host);
};

export const useIsBellaPageType = () => {
    const { host } = useRouter();
    const { links } = useConfig();

    return useCallback(
        (url: string) => {
            const { pageType, relativeUrl } = getPageTypeByUrl(url, host, links);
            return { isBellaPage: bellaPageTypes.includes(pageType), relativeUrl };
        },
        [host, links]
    );
};

export const isClubPageType = (pageType: PageType) => clubMFPageTypes.includes(pageType);

export const useIsClubMFUrl = (url: string) => {
    const { host } = useRouter();
    const { links } = useConfig();
    const { pageType } = getPageTypeByUrl(url, host, links);
    return isClubPageType(pageType);
};

export { PageType };
